module.exports = __webpack_public_path__ + "static/Q6Answer3_BeingIgnored_allisonShaw-4bf26e385c50183bc4c7f1e0509c95bd.jpg";